<template>
	<div class="icon-telegram">
		<svg
			width="24.000000"
			height="24.000000"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs />
			<path
				id="path"
				d="M24 12C24 18.62 18.62 24 12 24C5.37 24 0 18.62 0 12C0 5.37 5.37 0 12 0C18.62 0 24 5.37 24 12ZM12.43 8.85C11.26 9.34 8.93 10.34 5.43 11.87C4.86 12.09 4.56 12.32 4.53 12.53C4.49 12.9 4.95 13.04 5.57 13.24C5.65 13.26 5.74 13.29 5.83 13.32C6.44 13.52 7.27 13.75 7.7 13.76C8.08 13.77 8.52 13.61 9 13.28C12.27 11.07 13.95 9.96 14.06 9.93C14.13 9.92 14.24 9.9 14.31 9.96C14.38 10.02 14.37 10.14 14.36 10.17C14.32 10.36 12.52 12.03 11.59 12.9C11.3 13.17 11.1 13.36 11.06 13.4C10.96 13.5 10.87 13.59 10.77 13.68C10.21 14.23 9.78 14.64 10.8 15.31C11.29 15.63 11.68 15.9 12.07 16.17C12.5 16.46 12.93 16.75 13.48 17.11C13.62 17.2 13.75 17.3 13.88 17.39C14.38 17.75 14.83 18.06 15.38 18.01C15.7 17.98 16.03 17.68 16.2 16.78C16.6 14.66 17.38 10.05 17.56 8.16C17.57 7.99 17.55 7.78 17.54 7.68C17.52 7.59 17.49 7.46 17.37 7.36C17.22 7.24 17 7.22 16.9 7.22C16.45 7.23 15.76 7.47 12.43 8.85Z"
				fill="#28A7E8"
				fill-opacity="1.000000"
				fill-rule="evenodd"
			/>
		</svg>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class IconTelegram extends Vue {}
</script>

<style scoped lang="scss">
.icon-telegram {
	display: flex;
}
</style>
